<main class="table-component-scss">
	<section
		class="w-full flex flex-row pl-[24px] pr-[24px] mb-[16px] relative"
		[class.mt-[60px]]="enabledSearch"
	>
		<div
			class="flex items-center justify-between flex-row w-full"
			[class.ml-[40px]]="formType === 'modal'"
		>
			@for (col of table.columns; track col) {
				@if (col.type === 'data') {
					<div
						class="flex overflow-hidden"
						[ngClass]="col.cssHeader ? col.cssHeader : ''"
						[ngClass]="col.icon ? col.icon : ''"
						[ngStyle]="{ width: getPercents(col.col) }"
					>
						<span class="text-xs no-select text text-font font-semibold">
							{{ col.label }}
						</span>
					</div>
				}
				@if (col.type === 'search') {
					<div
						class="flex items-center justify-center h-[40px]"
						[ngStyle]="{ width: getPercents(col.col) }"
					>
						<input
							id="inputSerchTable"
							#inputCheckSearch
							(change)="openSearch(inputCheckSearch, inputCheckSearch)"
							class="absolute left-[0px] top-0 label-search hidden"
							type="checkbox"
							checked="checked"
						/>
						@if (enabledSearch) {
							<div
								class="left-[0px] -top-[50px] bg-gray-50 absolute ls-input-container mt-[7px] zi-700 rounded-lg border-solid border border-primary"
							>
								<div class="flex flex-row justify-between w-full h-[40px] items-center">
									<label for="inputSerchTableDisable" class="cursor-pointer">
										<div
											class="icon-search flex justify-center items-center text-primary h-[40px] w-10 ml-[4px]"
										></div>
									</label>
									<div class="w-px bg-gray-600 ml-[10px] h-[12px] mr-[12px]"></div>
									<input
										(keyup)="searchString(inputSearch)"
										#inputSearch
										class="w-full bg-transparent border-none text-gray-700 text-sm"
										placeholder="O que você procura ?"
									/>
								</div>
							</div>
						}
					</div>
				}
				@if (col.type === 'three-action') {
					<div
						[ngClass]="col.icon ? col.icon : ''"
						[ngStyle]="{ width: getPercents(col.col) }"
					></div>
				}
				@if (col.type === 'spacing' || col.type === 'action-flag-to-delete') {
					<div [ngClass]="col.css ? col.css : ''" [style.width.px]="col.size"></div>
				}
				<!-- <div *ngIf="col.type === 'none' || col.type === 'details-table' " [ngClass]="col.icon? col.icon : ''" [ngStyle]="{'width': getPercents(col.col)}"></div> -->
			}

			<!-- Gambiarra para alinhar titulos -->
			<div [ngStyle]="{ width: getPercents(1) }"></div>
		</div>
	</section>

	<section class="flex flex-col relative w-full mt-[8px]">
		@for (lane of table.body; track lane; let index = $index) {
			<div
				#itemList
				[class.mt-[8px]]="index > 0"
				[class.ttfc-data-motion-prev]="paginationType === 'prev'"
				[class.motion-go-right]="paginationType === 'prev'"
				[class.motion-go-left]="paginationType === 'next'"
				[style.animation-delay.ms]="index * 60"
				class="tsec-container"
			>
				@if (formType === 'modal' && enableCheckItens) {
					<section class="absolute top-13 left-[7px] w-[50px]">
						<lbca-input-checkmark
							[entityKey]="checkboxEntityKey"
							[disabled]="false"
							[options]="[{ id: lane.id, label: '' }]"
							[checked]="checkItens"
							(changeValue)="changeCheckedItens($event)"
						></lbca-input-checkmark>
					</section>
				}
				@for (col of table.columns; track col) {
					@if (col.type === 'action-delete') {
						<section
							class="table-secondary-confirm-remove z-0"
							[class.shake-horizontal]="lane.confirmDelete"
							[class.contentDelete]="lane.delete"
							[class.notContentDelete]="!lane.delete"
						>
						<lbca-icon name="lucide:trash" class="table-trash" (click)="col.functionDelete(lane)"></lbca-icon>
						</section>
					}
				}
				<div
					#headerRef
					class="tsec-principal"
					[class.shadow]="openExpanded"
					[class.formPrimary]="formType === 'form-primary'"
					[class.modal]="formType === 'modal'"
					[class.shake-horizontal]="lane.confirmDelete"
					[class.triggered-focus]="lane.id === cardInfo.eventTriggeredBy"
					[ngClass]="{
						'ml-[40px] w-[98%]': checkLineDeslocation(lane),
						'w-full': !checkLineDeslocation(lane)
					}"
				>
					@for (col of table.columns; track col) {
						@if (
							col.type !== 'three-action' &&
							col.type !== 'action-delete' &&
							col.type !== 'spacing' &&
							col.type !== 'action-flag-to-delete' &&
							col.type !== 'details-table'
						) {
							<div
								class="flex items-center relative overflow-hidden"
								[ngClass]="col.css ? col.css : ''"
								[ngStyle]="{ width: getPercents(col.col) }"
							>
								@if (!col['templateRef'] && !col['field']) {
									<div [lbcaTable]="col" [laneData]="lane" class="w-full text-xs text"></div>
								}
								@if (!col['templateRef'] && col['field']) {
									<div class="w-full text-xs text">
										<ng-container
											[ngTemplateOutlet]="formFields"
											[ngTemplateOutletContext]="{ $implicit: lane, col: col, labeled: false }"
										></ng-container>
									</div>
								}
								@if (col['templateRef']) {
									<ng-container
										[ngTemplateOutlet]="col.templateRef"
										[ngTemplateOutletContext]="{ $implicit: lane }"
									></ng-container>
								}
							</div>
						}
						@if (col.type === 'three-action') {
							<div
								(click)="stopPropagation($event)"
								class="flex items-center justify-end relative"
								[ngStyle]="{ width: getPercents(col.col) }"
							>
								<label
									for="tertiary-actions-{{ index }}"
									class="flex items-center cursor-pointer h-[24px] w-6 justify-center relative"
								>
									<span class="tertiary-actions"></span>
									<input
										lbcaTableClickOutside
										id="tertiary-actions-{{ index }}"
										type="checkbox"
										class="hidden dropdown-select"
									/>
									<div
										class="w-196 top--4 max-h-[224px] bg-gray-200 text-xs right-0 shadow-md rounded absolute dropdown-content hidden show pt-[16px] pb-[16px]"
									>
										<div class="w-full h-full overflow-y-auto">
											@for (act of col.actions; track act) {
												<div
													(click)="act.function(lane)"
													class="w-full h-[32px] flex items-center pl-[32px] cursor-pointer text-sm tracking-[1px]"
												>
													{{ act.label }}
												</div>
											}
										</div>
									</div>
								</label>
							</div>
						}
						<!-- <div
                  *ngIf="col.type === 'details-table'"
                  (click)="abre(detailsView, angleRef, headerRef)"
                  class="flex items-center justify-end relative"
                  [ngStyle]="{'width': getPercents(col.col)}">
                  <label class="flex items-center cursor-pointer h-[24px] w-6  justify-center relative">
                    <div  class="svg-icon-angle bg-gray-600 transition duration-400 ease-in-out"
                      [class.rotate-180]="openExpanded"
                    #angleRef></div>
                  </label>
                </div> -->
						@if (col.type === 'spacing') {
							<div [ngClass]="col.css ? col.css : ''" [style.width.px]="col.size"></div>
						}
						@if (col.type === 'action-flag-to-delete') {
							<div>
								@if (col['templateRef']) {
									<ng-container
										[ngTemplateOutlet]="col.templateRef"
										[ngTemplateOutletContext]="{ $implicit: lane }"
									></ng-container>
								}
							</div>
						}
					}
					@if (table.details.length) {
						<div
							(click)="abre(detailsView, angleRef, headerRef)"
							class="flex items-center justify-end relative"
							[ngStyle]="{ width: getPercents(1) }"
						>
							<label class="flex items-center cursor-pointer h-[24px] w-6 justify-center relative">
								<div
									class="svg-icon-angle bg-gray-600 transition duration-400 ease-in-out"
									[class.rotate-180]="openExpanded"
									#angleRef
								></div>
							</label>
						</div>
					}
				</div>
				<div
					class="tsec-details"
					#detailsView
					[class.open]="openExpanded"
					[class.visibleStrategy]="openExpanded"
					[class.close]="!openExpanded"
					[class.formPrimary]="formType === 'form-primary'"
					[class.modal]="formType === 'modal'"
				>
					@for (col of table.details; track col) {
						<div
							[ngClass]="'ff-field-size-' + col['field'].size"
							class="ff-box-field ff-grid-field"
						>
							<ng-container
								[ngTemplateOutlet]="!lane['description'] ? formFields : descriptionTemp"
								[ngTemplateOutletContext]="{ $implicit: lane, col: col, labeled: true }"
							></ng-container>
						</div>
					}
				</div>
			</div>
		}
	</section>

	<section class="flex flex-col relative w-full mt-[8px] mb-[40px]">
		<div
			class="flex items-center justify-between flex-row w-full"
			[class.ml-[40px]]="formType === 'modal'"
		>
			@for (col of table.columns; track col; let i = $index) {
				@if (col.type === 'data') {
					<div
						class="flex overflow-hidden"
						[ngClass]="col.cssFooter ? col.cssFooter : ''"
						[ngClass]="col.icon ? col.icon : ''"
						[ngStyle]="{ width: getPercents(col.col) }"
					>
						@if (col['templateFooter']) {
							<!-- <ng-container
                  [ngTemplateOutlet]="col.templateFooter"
                  [ngTemplateOutletContext]="{ $implicit: lane }"
                  >
                </ng-container> -->
						}
					</div>
				}
				@if (
					col.type === 'search' ||
					col.type === 'three-actio=n' ||
					col.type === 'none' ||
					col.type === 'spacing'
				) {
					<div
						class="flex items-center justify-center h-[40px]"
						[ngStyle]="{ width: getPercents(col.col) }"
					></div>
				}
			}
		</div>
	</section>
</main>

<ng-template #ModalText>
	<section class="inline-flex w-full mb-[40px]">
		<div
			class="svg-icon-arrow w-6 h-[24px] bg-primary mt-[15px] mr-[15px]"
			(click)="closeModal()"
		></div>
		<div class="flex flex-col">
			<div
				class="text-center -ml-[5px] justify-center flex items-center text-xl w-[51px] h-[51px] rounded-full bg-gray-200 border-gray-600 text-gray-600 border border-solid"
			>
				{{ getInicials(modalItems.user) }}
			</div>
		</div>
		<div class="flex flex-col mt-[10px]">
			<div class="text-base text-primary ml-[25px]">{{ modalItems.user }}</div>
			<div class="text-xs text-gray-600 ml-[25px]">{{ modalItems.dataCriacao }}</div>
		</div>
	</section>

	<section class="form-fields-sub-module-modal">
		<div class="ff-row-form overflow-x-hidden">
			<div class="ff-box-field ff-field-size-7">
				{{ modalItems.description }}
			</div>
		</div>
	</section>

	<section class="flex mt-[40px] absolute bottom-30">
		<button type="button" class="btn-primary btn-type-2 ml-[4px]" (click)="closeModal()">
			Cancelar
		</button>
	</section>
</ng-template>

<ng-template #formFields let-lane let-col="col" let-labeled="labeled">
	@if (
		col['field'].type === 'TABLE==========_LIST' &&
		lane[col.field.entityKey] &&
		lane[col.field.entityKey] !== null
	) {
		<lbca-table-list [cardData]="cardInfo"
			[disabled]="true"
			[field]="col['field']"
			[body]="lane[col.field.entityKey]"
		 />
	}

	@if (col['field'].type === 'HIDDEN') {
		<lbca-input-hidden [label]="col['field'].label"
			[defaultValue]="col['field'].defaultValue"
		 />
	}
	@if (col['field'].type === 'INPUT_REF') {
		<legalboxplus-input-reference [cardData]="cardInfo"
			[field]="col['field']"
			[value]="lane[col.name]"
		 />
	}
	@if (col['field'].type === 'ADDITIONAL_VALUES_CONDENSED') {
		<lbca-additional-values-condensed [field]="col['field'].fields"
			[disabled]="col['field'].disabled"
			[cardData]="cardInfo"
			[value]="lane"
		 />
	}
	@if (col['field'].type === 'ADDITIONAL_VALUES') {
		<lbca-additional-values [field]="col['field'].fields"
			[disabled]="col['field'].disabled"
			(changeValue)="changeValueAdditional($event, col['field'].fields, lane)"
			[cardData]="cardInfo"
			[value]="lane"
		 />
	}
	@if (col['field'].type === 'TEXT') {
		<lbca-input-text [label]="col['field'].label"
			[tabeled]="!labeled"
			[labeled]="!labeled"
			[editable]="col['field'].editable && !disabled"
			[disabled]="col['field'].disabled"
			[error]="[]"
			[require]="col['field'].required"
			[maskInput]="col['field'].mask"
			[value]="lane[col.name]"
			(changeValue)="changeValue($event, col['field'], lane)"
		 />
	}
	@if (col['field'].type === 'DATE_TIME') {
		<lbca-date-time-picker [value]="lane[col.name]"
			[labeled]="!labeled"
			[tabeled]="!labeled"
			[editable]="col['field'].editable && !disabled"
			[disabled]="col['field'].disabled"
			[labelDate]="col['field'].labelDate"
			[labelTime]="col['field'].labelTime"
			[require]="col['field'].required"
			[error]="[]"
			[rules]="col['field'].rules"
			[disabledDateRules]="col['field'].disabledDateRules"
			(changeValue)="changeValue($event, col['field'], lane)"
		 />
	}
	@if (col['field'].type === 'CALENDAR') {
		<lbca-date-picker [labeled]="!labeled"
			[tabeled]="!labeled"
			[editable]="col['field'].editable && !disabled"
			[label]="col['field'].label"
			[disabled]="col['field'].disabled"
			[require]="col['field'].required"
			[rules]="col['field'].rules"
			[disabledDateRules]="col['field'].disabledDateRules"
			[error]="[]"
			[value]="lane[col.name]"
			(changeValue)="changeValue($event, col['field'], lane)"
		 />
	}

	@if (col['field'].type === 'TIME') {
		<lbca-timepicker [labeled]="!labeled"
			[tabeled]="!labeled"
			[label]="col['field'].label"
			[editable]="col['field'].editable && !disabled"
			[require]="col['field'].required"
			[disabled]="col['field'].disabled"
			[error]="[]"
			[value]="lane[col.name]"
			(changeValue)="changeValue($event, col['field'], lane)"
		 />
	}
	@if (col['field'].auxEntity) {
		<lbca-entity-fields [forceType]="'SELECT_ONE'"
			[tabeled]="!labeled"
			[labeled]="!labeled"
			[editable]="col['field'].editable && !disabled"
			[disabled]="col['field'].disabled"
			[field]="col['field']"
			[label]="col['field'].label"
			[error]="[]"
			[require]="col['field'].required"
			[value]="lane[col.name]"
			[cardData]="cardInfo"
			(changeValue)="changeValue($event, col['field'], lane)"
		 />
	}
</ng-template>

<ng-template #descriptionTemp let-lane let-col="col">
	@if (openExpanded) {
		@if (col['field'].type === 'TEXTAREA') {
			<lbca-textarea [label]="col['field'].label"
				[disabled]="col['field'].disabled"
				[error]="[]"
				[value]="lane[col.name]"
				[require]="col['field'].required"
				(changeValue)="changeValue($event, col['field'], lane)"
			 />
		}
	}
	@if (!openExpanded && col['field'].type === 'TEXTAREA') {
		<div class="text-sm text-font mb-[20px]">
			{{
				lane['description'].length > 500
					? (lane['description'] | slice: 0 : 500) + '... '
					: lane['description']
			}}
		</div>
		@if (lane['description'].length > 500) {
			<div class="ff-box-field ff-field-size-7 text-right">
				<a class="text-xs text-primary" (click)="openModal(lane)">Ver mais</a>
			</div>
		}
	}
</ng-template>
